"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isWordPress;

var _parseQueryString = _interopRequireDefault(require("./parseQueryString"));

function isWordPress() {
  try {
    if (window.top !== window) {
      var queryString = (0, _parseQueryString.default)();
      return !!queryString.wp;
    }
  } catch (e) {//
  }

  return false;
}

module.exports = exports.default;